import React from 'react';

import { AddressIcon, DollarIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';

import {
  fixedTwoFractionDigitsExceptIntegerCurrencyOptions,
  OccupancyTypeLabel,
} from 'constants/loanApplication';
import { propertyTypeOptionsMap } from 'constants/options';
import { StatusColor, StatusEnum } from 'constants/status';
import { formatNumberToCurrencyString } from 'utils/number';
import { getModifiedFieldChangeKind } from 'utils/pendingChangeKind';

import PitiData from '../PitiData';
import { PITI_PENDING_CHANGES_KEY } from '../PitiData/PitiData.constants';

import { commonTooltipStyles } from './PropertyAndLoanSummary.styles';
import { getPropertyAddressValue } from './PropertyAndLoanSummary.utils';

const SUMMARY_CARDS_NAMES = {
  PROPERTY_ADDRESS: 'Property Address',
  PROPERTY_TYPE: 'Property Type',
  OCCUPANCY: 'Occupancy',
  PROPERTY_EXPENSES: 'Property Expenses',
};

export const getSummaryInfoConfig = subjectPropertyData => {
  return [
    {
      name: SUMMARY_CARDS_NAMES.PROPERTY_ADDRESS,
      value: getPropertyAddressValue(subjectPropertyData),
      icon: <AddressIcon />,
      iconColor: StatusColor[StatusEnum.SUCCESS],
      changeKind: getModifiedFieldChangeKind(subjectPropertyData, 'PropertyAddress'),
      pendingChangesKey: 'PropertyAddress',
      noTruncate: true,
    },
    {
      name: SUMMARY_CARDS_NAMES.PROPERTY_TYPE,
      value: propertyTypeOptionsMap[subjectPropertyData.propertyType?.type]?.name,
      icon: <DollarIcon />,
      changeKind: getModifiedFieldChangeKind(subjectPropertyData, 'PropertyType'),
      pendingChangesKey: 'PropertyType',
    },
    {
      name: SUMMARY_CARDS_NAMES.OCCUPANCY,
      value: OccupancyTypeLabel[subjectPropertyData.occupancy?.type],
      icon: <DollarIcon />,
      changeKind: getModifiedFieldChangeKind(subjectPropertyData, 'Occupancy'),
      pendingChangesKey: 'Occupancy',
    },
    {
      name: SUMMARY_CARDS_NAMES.PROPERTY_EXPENSES,
      value: formatNumberToCurrencyString(
        subjectPropertyData.piti ?? 0,
        fixedTwoFractionDigitsExceptIntegerCurrencyOptions,
      ),
      icon: <DollarIcon />,
      iconColor: StatusColor[StatusEnum.ERROR],
      changeKind: getModifiedFieldChangeKind(subjectPropertyData, PITI_PENDING_CHANGES_KEY),
      pendingChangesKey: PITI_PENDING_CHANGES_KEY,
      withInfoIcon: true,
      disableInteractive: false,
      hoverContent: <PitiData data={subjectPropertyData} />,
      customTooltipStyles: commonTooltipStyles,
    },
  ];
};
